// removed by extract-text-webpack-plugin
module.exports = {"nav":"_2lmEf","active":"_1WE-6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AppHeader/Navigation/style.scss
// module id = BCqG
// module chunks = 0